import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToggleSwitchComponent } from '../toggle-switch/toggle-switch.component';

@Component({
  selector: 'app-user-info-panel',
  imports: [CommonModule, ToggleSwitchComponent],
  templateUrl: './user-info-panel.component.html',
  styleUrl: './user-info-panel.component.css',
})
export class UserInfoPanelComponent {
  @Input() userName!: string;
  @Input() userAddress!: string;
  @Input() isActive: boolean = false;
  @Output() toggleChange = new EventEmitter<boolean>();
  
  constructor(private router: Router) {
   
  }  

  handleToggle(event: boolean) {
    this.toggleChange.emit(event);
  }
}
